import { CartChange } from "custom-types/Cart";

import Notification, { NotificationSize } from "../Notification";

const InvalidItemsNotification: React.FC<{
  invalidItems: CartChange[];
}> = ({ invalidItems }) => {
  if (!invalidItems.length) {
    return null;
  }
  return (
    <>
      {invalidItems.map((item) => (
        <Notification
          className="mb-md pr-lg"
          isFilled
          key={`${item.item_name} ${item.message}`}
          message={`${item.message}`}
          size={NotificationSize.SMALL}
        />
      ))}
    </>
  );
};

export default InvalidItemsNotification;
